import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../../shared/NavBar';
import PageMetadata from '../../shared/PageMetadata';
import { PAGE_METADATA } from '../../pageMetadata';
import laptopMockup from '../../assets/laptop-mockup.png';
import { clubOutreachPath, clubOutreachTitle, clubOutreachLead, clubOutreachSteps, clubOutreachPlans, clubOutreachAllowances, clubOutreachExample, clubOutreachCosts, clubOutreachFeeNote, clubOutreachLinks } from './clubOutreachContent';
import './ClubOutreachPage.css';

export default function ClubOutreachPage() {
  useEffect(() => {
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `https://www.shuttleops.com${clubOutreachPath}`;
    document.head.appendChild(canonical);
    return () => canonical.remove();
  }, []);

  return <>
    <PageMetadata metadata={PAGE_METADATA[clubOutreachPath]} />
    <header className="club-outreach-hero">
      <NavBar />
      <div className="club-outreach-intro">
        <div>
          <h1>{clubOutreachTitle}</h1>
          <p>{clubOutreachLead}</p>
          <Link to="/test-club" className="club-outreach-start" data-test-club-cta="outreach-hero">Try a free test club <span aria-hidden="true">→</span></Link>
          <small>Seven days. 10 fake players. No card or setup call.</small>
        </div>
        <img src={laptopMockup} alt="ShuttleOps Digital Peg Board showing a badminton session across four courts" />
      </div>
    </header>
    <main className="club-outreach-main">
      <section aria-labelledby="club-night-title" className="club-outreach-night">
        <h2 id="club-night-title">One place for your whole club night</h2>
        <ol>{clubOutreachSteps.map(([when, title, text]) => <li key={when}><span>{when}</span><div><h3>{title}</h3><p>{text}</p></div></li>)}</ol>
      </section>
      <section className="club-outreach-plans" aria-labelledby="club-plans-title">
        <h2 id="club-plans-title">Plans for your club</h2>
        <p>{clubOutreachPlans}</p><p>{clubOutreachAllowances}</p>
      </section>
      <section className="club-outreach-value" aria-labelledby="club-value-title">
        <div><h2 id="club-value-title">What does a 30-player club cost?</h2><p>{clubOutreachExample}</p></div>
        <div><h3>Monthly Pro example</h3><p>{clubOutreachCosts}</p>
          <details><summary>How are payment fees calculated?</summary><p>{clubOutreachFeeNote}</p></details>
        </div>
      </section>
      <div className="club-outreach-next"><p>Include the time you spend on admin and payments you miss when you estimate your club’s value.</p>
        <nav aria-label="Club costs and plans">{clubOutreachLinks.map(([href, text]) => <Link key={href} to={href}>{text} <span aria-hidden="true">→</span></Link>)}</nav>
      </div>
    </main>
  </>;
}
